<template>
  <div>
    <el-card class="h-full" :body-style="{ height: '100%' }">
      <div class="text-right">
        <el-button size="small" type="primary" @click="operateDistributeConfig">保存</el-button>
        <el-button @click="clickCancel" size="small">取消</el-button>
      </div>
      <div class="config-title pl-10px mb-10px">分发配置</div>
      <el-form
        :model="queryData"
        :rules="formRule"
        class="form-height"
        label-position="right"
        label-width="120px"
        ref="form"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item label="分发配置名称" prop="name">
              <el-input clearable v-model="queryData.name" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="数据标准库">
              <selectStandardId @updateStandardId="updateStandardId" class="!w-full" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="主数据类型" prop="typeId">
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="queryData.typeId"
                size="small"
              >
                <el-option
                  v-for="item in masterDataTypeList"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                  @click.native="clickMasterType(item)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="主数据名称" prop="classId">
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="queryData.classId"
                size="small"
              >
                <el-option
                  v-for="item in classIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="clickClassId(item)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="备注">
              <el-input v-model="queryData.remark" size="small" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="config-title pl-10px mb-10px">数据预览</div>
        <el-table
          border
          height="calc(100% - 350px)"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          :row-key="(record) => record.id"
          ref="multipleTable"
          :data="listData"
          v-loading="tableLoading"
        >
          <el-table-column
            v-if="headerData.length"
            :reserve-selection="true"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            v-for="item in headerData"
            :key="item.code"
            :prop="item.column"
            show-overflow-tooltip
            :label="item.name"
          ></el-table-column>
        </el-table>
        <div class="tr">
          <el-pagination
            class="mt-20px"
            background
            :current-page.sync="pageNo"
            :page-size.sync="pageSize"
            @current-change="getDataPreviewList(currentItemClassId)"
            @size-change="sizeChange"
            :page-sizes="$pageSizeAll"
            layout="->, total, sizes, prev, pager, next, jumper"
            :total="recordCount"
          ></el-pagination>
        </div>

        <el-row :gutter="40" class="mt-20px">
          <el-col class="distribute-btn" :span="2">
            <el-button @click="createApi" size="small" type="primary">生成API</el-button>
          </el-col>
          <el-col :span="22">
            <el-form-item label="API格式" prop="apiAddress">
              <el-input readonly clearable v-model="queryData.apiAddress" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="distribute-btn" :span="2"> </el-col>
          <el-col :span="22">
            <el-form-item label="接口密钥" prop="token">
              <el-input readonly clearable size="small" v-model="queryData.token"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import MasterDataManageService from '@/services/masterDataManageService'
import selectStandardId from '../../components/selectStandardId'

export default {
  components: { selectStandardId },
  watch: {
    'queryData.typeId': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.pageNo = 1
          if (oldValue && oldValue !== newValue) {
            this.isTypeIdChange = true
          }
        }
      },
    },
    // standardId: {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.queryData.typeId = ''
    //       this.queryData.classId = ''
    //       this.headerData = []
    //       this.listData = []
    //       this.classIdList = []
    //       this.getMasterDataType()
    //     }
    //   },
    // },
  },

  data() {
    return {
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      standardId: localStorage.getItem('standardId'),
      queryData: {
        name: '',
        address: '',
        typeId: '',
        classId: '',
        className: '',
        distributeCount: '',
        remark: '',
        apiAddress: '',
        token: '',
      },
      masterDataTypeList: [],
      formRule: {
        name: [{ required: true, message: '请输入分发配置名称', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择主类型类型', trigger: ['blur', 'change'] }],
        classId: [{ required: true, message: '请选择主类型名称', trigger: ['blur', 'change'] }],
        apiAddress: [{ required: true, message: '请输入API格式', trigger: ['blur', 'change'] }],
        token: [{ required: true, message: '请输入接口密钥', trigger: ['blur', 'change'] }],
      },
      masterDataType: '',
      headerData: [],
      listData: [],
      tableLoading: false, // 列表loading
      operateMode: '',
      totalSelection: [],
      currentItemTypeId: '',
      showTable: false,
      currentItemClassId: '',
      isUserSelected: false, // 用户是否手动勾选列表中的checkbox
      isTypeIdChange: false, // 主数据类型选项是否切换了
      selectedRowIds: [], // 编辑初始化时选中的列
      isEditInit: true, // 是否是编辑初始化
      classIdList: [],
      type: '', // 新增还是编辑
    }
  },
  methods: {
    // 根据主数据类型id获取实体数据
    async getClassList() {
      const parameter = {
        // standard_id: this.standardId,
        keyword: '',
        pageno: 1,
        pagesize: 999,
        data_type: 1,
        approve_status: 1,
        data_main_type_id: this.currentItemTypeId,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classIdList = res.data
      }
    },
    updateStandardId(val) {
      this.standardId = val
    },
    async clickMasterType(item) {
      this.currentItemTypeId = item.id
      this.queryData.classId = ''
      this.headerData = []
      this.listData = []
      await this.getClassList()
      // this.currentItemClassId = item.children[0].id
      // this.getDataPreviewList(item.classId)
    },
    clickClassId(item) {
      this.queryData.className = item.name
      this.getDataPreviewList(item.id)
    },
    /**
     * @description 跨页多选
     * @param {Array} val 当前列表选中项
     */
    handleSelectionChange(val) {
      // if (!this.isUserSelected) return
      this.totalSelection = val
    },

    /**
     * @description 用户手动勾选checkbox时触发的事件
     * @param {Array} selectedItem 当前列表勾选数据
     * @param {Object} row 当前勾选项
     */
    handleSelect(selectedItem, row) {
      this.isUserSelected = true
      if (this.isTypeIdChange) {
        this.$refs.multipleTable && this.$refs.multipleTable.clearSelection()
        this.$nextTick(() => {
          this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(row, true)
        })
        this.isTypeIdChange = false
      }
    },
    /**
     * @function 生成API
     */
    async createApi() {
      const res = await MasterDataManageService.createNewAPI()
      if (res && res.code === 0 && res.data) {
        this.queryData.apiAddress = res.data.apiUri
        this.queryData.token = res.data.token
      }
    },

    /**
     * @function 编辑初始化
     */
    async editInit() {
      if (this.$route.query.item) {
        this.operateMode = 'edit'
        this.queryData = JSON.parse(decodeURIComponent(this.$route.query.item))
        this.selectedRowIds = [...this.queryData.dataIds.split(',')]
        this.currentItemTypeId = this.queryData.typeId
        this.currentItemClassId = this.queryData.classId
        await this.getClassList()
        this.getDataPreviewList(this.queryData.classId)
      }
    },

    /**
     * @description 编辑时，跨页多选项勾选
     */
    selectedRow() {
      _.forEach(this.totalSelection, (item) => {
        const findItem = _.find(this.listData, ['id', item.id])
        if (findItem) {
          this.$nextTick(() => {
            this.$refs.multipleTable.toggleRowSelection(findItem, true)
          })
        }
      })
    },

    /**
     * @function 操作分发配置
     */
    operateDistributeConfig() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = null
          const paramster = _.cloneDeep(this.queryData)
          paramster.dataIds = _.map(this.totalSelection, (i) => {
            return i.id
          }).join(',')
          paramster.typeId = this.currentItemTypeId
          paramster.standardId = this.standardId
          if (this.operateMode !== 'edit') {
            res = await MasterDataManageService.createDistributeConfig(paramster)
            if (res && res.code === 0 && res.data) {
              this.$message({
                type: 'success',
                message: res.msg,
              })
              this.$router.push('./data-distribute')
            }
          } else {
            res = await MasterDataManageService.editDistributeConfig(paramster)
            if (res && res.code === 0 && res.data) {
              this.$message({
                type: 'success',
                message: res.msg,
              })
              this.$router.push('./data-distribute')
            }
          }
        }
      })
    },

    /**
     * @function 获取数据预览列表
     * @param {string} item 主数据类型
     */
    async getDataPreviewList(item) {
      const parameter = {
        class_id: item || this.currentItemClassId,
        pageno: this.pageNo,
        pagesize: this.pageSize,
      }
      this.tableLoading = true
      const res = await MasterDataManageService.getmasterDataList(parameter)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.headerData = res.data.headers
        this.listData = res.data.datas
        if (res.data.datas.length) {
          this.showTable = true
        }
        this.recordCount = res.page.recordCount
        if (this.queryData.dataIds && this.isEditInit) {
          _.forEach(this.selectedRowIds, (item) => {
            const findItem = _.find(this.listData, ['id', item])
            const findItemInSelection = _.find(this.totalSelection, ['id', item])
            if (findItem && !findItemInSelection) {
              this.totalSelection.push(findItem)
            }
          })
          this.isEditInit = false
        }
        this.selectedRow()
      }
    },

    /**
     * @function 获取主数据类型
     */
    async getMasterDataType() {
      // const params = {
      //   StandardId: this.standardId,
      // }
      const res = await MasterDataManageService.getList()
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.masterDataTypeList = res.data
      } else {
        this.masterDataTypeList = []
      }
    },

    /**
     * @function 点击取消
     */
    clickCancel() {
      this.$router.push('./data-distribute')
    },

    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.pageNo = 1
      this.getDataPreviewList(this.currentItemClassId)
    },
  },
  async created() {
    this.type = this.$route.query.type
    await this.getMasterDataType()
    this.editInit()
  },
}
</script>

<style lang="scss" scoped>

.input-width {
  width: 200px;
}
.form-height {
  height: 93%;
}
.distribute-btn {
  height: 40px;
  line-height: 40px;
}
.config-title {
  border-left: 2px solid #3686ef;
  font-size: 18px;
}

</style>
